import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { NavigationStart, Router } from '@angular/router';
import { ToastMessage } from 'src/app/models/internal/toastmessage';
import { LocalstorageService } from '../localstorage.service';
import { Constants } from 'src/app/core/constants';

@Injectable()
export class ToastService {
  private subject = new Subject<ToastMessage>();
  private keepAfterRouteChange = false;
  private style: string;
  private className: string;
  constructor(private router: Router,
    private localstorageService: LocalstorageService,
    ) {
   router.events.subscribe(event => {
    if (event instanceof NavigationStart) {
     if (this.keepAfterRouteChange) {
      this.keepAfterRouteChange = false;
     } else {
      this.clear();
     }
    }
   });
  }
 getToast(): Observable<any> {
  return this.subject.asObservable();
 }
  success(message: string, keepAfterRouteChange = true, className = Constants.DefaultClassName): void {
    this.toast(message, 'success', keepAfterRouteChange, className);
 }
  error(message: string, keepAfterRouteChange = true, className = Constants.DefaultClassName): void {
   // prefix with correlation Id
  const correlationId = this.localstorageService.retrieve(Constants.localStorageKeys.CorrelationId);
    this.toast(`[${correlationId}]: ${message}`, 'error', keepAfterRouteChange, className);
 }
  info(message: string, keepAfterRouteChange = true, className = Constants.DefaultClassName): void {
    this.toast(message, 'info', keepAfterRouteChange, className);
 }
  alert(message: string, keepAfterRouteChange = true, className = Constants.DefaultClassName): void {
    this.toast(message, 'alert', keepAfterRouteChange, className);
 }

//  warning(message: string, keepAfterRouteChange = true): void {
//   this.toast(message, 'warning',  keepAfterRouteChange);
//  }
  toast(message: string, style: string, keepAfterRouteChange = true, className: string): void {
  this.keepAfterRouteChange = keepAfterRouteChange;
  this.style = style;
    this.className = className;
    this.subject.next(<ToastMessage>{ message: message, style: style, className: className });
 }
 clear() {
  this.subject.next();
 }
}